import React, {Component} from 'react';
import _ from "underscore";
import CircularProgress from 'material-ui/CircularProgress';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import LocatorForm from "./LocatorForm";
import GoogleMap from './GoogleMap';
import SurveyForm from "./survey/SurveyForm";
import LocationDetail from "./LocationDetail";
import api from '../../api/api';
import DataStore from '../../api/DataStore';
import DataManager from '../../api/DataManager';
import ResponsiveLayout from '../common/ResponsiveLayout';
import Tracker from '../common/Tracker';

import logo from "../../img/nica-logo.svg";
import mobileLogo from '../../img/ic-n-i-c-a-logo-small.svg';

import "../../css/Locator.css";
import "../../css/LocatorMobile.css";

const dataStore = new DataStore()
const CATEGORY = "locator";
const dataManager = new DataManager();

class LocatorDesktopLayout extends Component {

    onGoToLocationManagerClick = () => {
        Tracker.trackEvent(CATEGORY, "go to manager click", "", "");
        document.location = "/#location-manager";
    }

    render() {
        return (
            <div className="locator-container">
                <div className="locator-form-wrapper">
                    <div className="locator-form-header">
                        <div style={{flex: 1}}>
                            <img src={logo} className="locatorFormHeaderLogo" onClick={this.props.openURL.bind(null, "https://infusioncenter.org")} alt="locator header"/>
                        </div>
                        <div className="locator-form-header-title">
                            INFUSION CENTER LOCATOR
                        </div>
                    </div>
                    {this.props.surveyAnswers ?
                        <LocatorForm
                            onSearchSubmit={this.props.searchSubmit}
                            results={this.props.results}
                            medicationsAvailable={this.props.medicationsAvailable}
                            plotResults={this.props.plotResults}
                            onMouseOver={this.props.onMouseOver}
                            onResultsMouseOut={this.props.onResultsMouseOut}
                            onLocationSelect={this.props.onLocationSelect} />
                        :
                        <SurveyForm
                            onSurveyComplete={this.props.onSurveyComplete}/>
                    }
                    <div className="locator-form-footer">
                        <div>
                            NICA Locator is Sponsored By:
                        </div>
                        <div>
                            {this.props.sponsors ?
                                this.props.sponsors.map((sponsor, index) => {
                                    return (
                                        <img src={sponsor.img} key={"sponsor-" + index} style={{margin: "0 10px 0 10px", cursor: "pointer"}} onClick={this.props.openURL.bind(null, sponsor.url)} alt="sponsor logo" />
                                    )
                                })
                                :
                                <CircularProgress size={20} style={{marginLeft: "15px"}} thickness={3} />
                            }
                        </div>
                    </div>
                </div>
                <div className="mapContent" style={{position: "relative"}}>
                    <GoogleMap
                        results={this.props.results}
                        focusedIndex={this.props.focusedIndex}
                        imageSize={118}
                        onLocationSelect={this.props.onLocationSelect} />
                    {dataStore.getUser() ?
                        <FlatButton
                            backgroundColor="#1c5c7f"
                            label="go to location manager"
                            onClick={this.onGoToLocationManagerClick}
                            style={{position: "absolute", top: "25px", right: "25px"}}
                            labelStyle={{color: "#ffffff", fontFamily: "Oswald", fontSize: "15px"}} />
                        :
                        null
                    }
                </div>
                <Dialog
                    title="Location Temporarily Closed"
                    actions={[
                        <FlatButton label="ok" onClick={this.props.closeDialog} />
                    ]}
                    modal={false}
                    open={this.props.showDialog}
                    onRequestClose={this.props.closeDialog}>
                    {this.props.closedReason}
                </Dialog>
            </div>
        );
    }
}

class LocatorMobileLayout extends Component {
    render() {
        if (!this.props.surveyAnswers) {
            return (
                <div className="locator-container-mobile">
                    <SurveyForm
                        onSurveyComplete={this.props.onSurveyComplete}/>
                </div>
            )
        }
        return (
            <div className="locator-container-mobile">
                <div className="locator-form-header-mobile">
                    <div style={{flex: 1}}>
                        <img src={mobileLogo} onClick={this.props.openURL.bind(null, "https://infusioncenter.org")} alt="nica logo"/>
                    </div>
                    <div className="locator-form-header-title-mobile">
                        INFUSION CENTER LOCATOR
                    </div>
                </div>
                <LocatorForm
                    onSearchSubmit={this.props.searchSubmit}
                    results={this.props.results}
                    medicationsAvailable={this.props.medicationsAvailable}
                    plotResults={this.props.plotResults}
                    onMouseOver={this.props.onMouseOver}
                    onResultsMouseOut={this.props.onResultsMouseOut}
                    onLocationSelect={this.props.onLocationSelect}
                    focusedIndex={this.props.focusedIndex} />
                <div className="locator-form-footer">
                    <div>
                        NICA Locator Sponsored By:
                    </div>
                    <div style={{display: "flex"}}>
                        {this.props.sponsors ?
                            this.props.sponsors.map((sponsor, index) => {
                                return (
                                    <img src={sponsor.img} key={"sponsor-" + index} style={{margin: "0 10px 0 10px", cursor: "pointer"}} onClick={this.props.openURL.bind(null, sponsor.url)} alt="sponsor logo" />
                                )
                            })
                            :
                            <CircularProgress size={20} style={{marginLeft: "15px"}} thickness={3} />
                        }
                    </div>
                </div>
                <Dialog
                    title="Location Temporarily Closed"
                    actions={[
                        <FlatButton label="ok" onClick={this.props.closeDialog} />
                    ]}
                    modal={false}
                    open={this.props.showDialog}
                    onRequestClose={this.props.closeDialog}>
                    {this.props.closedReason}
                </Dialog>
            </div>
        )
    }
}

class Locator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            surveyAnswers: dataStore.getUserSurvey(),
            results: [],
            filteredResults: [],
            location: false,
            selectedLocation: this.props.location[1],
            sponsors: null,
            mapCenter: null,
            mapZoom: null,
            focusedIndex: null,
            showDialog: false
        }

    }
    componentWillMount() {
        if (this.state.surveyAnswers) {
            // console.log("setting custom dimension: %s", this.state.surveyAnswers.why['_gadim']);
            Tracker.setCustomDimension('dimension1', this.state.surveyAnswers.why['_gadim']);
        }
        Tracker.trackPageView("locator");

        api.getSponsors((sponsors) => {
            this.setState({sponsors: sponsors});
        });

        if(!this.state.allAttributes){
            this.setState({allAttributes: this.props.allAttributes});
        }

        dataManager.fetchUser();
    }

    onLocationChange = (lat, lng) => {
        this.setState({
            mapCenter: {lat: lat, lng: lng},
            mapZoom: 11
        });
    }

    searchSubmit(query, radius) {
        this.setState({results: []})
        api.geoCodeQuery(query, (lat, lng) => {
            this.setState({
                currentLocation: {
                    lat: lat,
                    lng: lng
                }
            });
            api.radiusSearch(lat, lng, radius, (key, location, distance) => {
                this.onResultReceived({lat: location[0], lng: location[1], key: key, distance: distance})
            });
        })
    }

    onResultReceived(result) {
        api.locationByKey(result.key, (location) => {
            _.extend(location, result);
            this.setState(prevState => {
                var results = prevState.results
                results.push(location)
                results.sort((l1, l2) => {
                    return ((l2.isPreferred || false) - (l1.isPreferred || false)) || (l1.distance - l2.distance);
                });

                return {results: results};
            });
        });
    }

    plotResults = (results, center) => {
        this.setState({results: results, mapCenter: center, mapZoom: 11});
    }

    onSurveyComplete = (answers) => {
        // console.log("onSurveyComplete");
        this.setState({surveyAnswers: answers});
        Tracker.setCustomDimension('dimension1', answers.why['_gadim']);
    }

    onLocationSelect = (location) => {
        Tracker.trackEvent(CATEGORY, "location selected", location.name, "");

        if (!location.temporarily_closed) {
            document.location.href = "#location/" + location.key;
        } else {
            this.setState({
                showDialog: true,
                closedReason: location.temporarily_closed_reason ? location.temporarily_closed_reason : "The Provider did not specify why this location is temporarily closed."
            });
        }
        // this.setState({selectedLocation: location})
    }

    onSelectionCleared = () => {
        this.setState({selectedLocation: false})
    }

    onMapInitialized = () => {

    }

    onMouseOver = (index) => {
        // console.log("onMouseOver: %d", index);
        this.setState({focusedIndex: index});
    }

    onResultsMouseOut = (event) => {
        this.setState({focusedIndex: null});
    }

    openURL = (url) => {
        window.open(url, '_blank');
    }

    closeDialog = () => {
        this.setState({showDialog: false, closedReason: null})
    }

    render() {
        return (
            <div style={{height: "100%", width: "100vw", position: "relative"}}>
                {this.props.locationKey ?
                    <div className="locator-details-container">
                        <LocationDetail
                            locationKey={this.props.locationKey}
                            onSelectionCleared={this.onSelectionCleared}/>
                    </div>
                    :
                    null
                }
                <ResponsiveLayout
                    desktopLayout={LocatorDesktopLayout}
                    mobileLayout={LocatorMobileLayout}
                    searchSubmit={this.searchSubmit}
                    plotResults={this.plotResults}
                    onMouseOver={this.onMouseOver}
                    onResultsMouseOut={this.onResultsMouseOut}
                    onLocationSelect={this.onLocationSelect}
                    onSurveyComplete={this.onSurveyComplete}
                    openURL={this.openURL}
                    closeDialog={this.closeDialog}
                    {...this.state} />

            </div>
        )

    }

}

export default Locator;



// WEBPACK FOOTER //
// ./src/components/locator/Locator.js